import { StyledImg } from "./SignatureBannerDefault.styles";
import { ToggleInput } from "components/ToggleInput";

type SignatureBannerDefaultProps = {
  banner: string;
  setBanner: (banner: string) => void;
  customPhone: string;
  setCustomPhone: (phone: string) => void;
  showBanner?: boolean;
  showControls?: boolean;
};

export const SignatureBannerDefault = ({
  banner,
  customPhone,
  setCustomPhone,
  showBanner = true,
  showControls = true,
}: SignatureBannerDefaultProps) => {

  const handleChange = (event: any) => {
    setCustomPhone(event.target.value);
  };

  return (
    <span>
      {showBanner ? (
        <a
          href="https://teltecsolutions.com.br/quem-somos/"
          rel="noopener noreferrer"
        >
          <StyledImg
            src={banner}
            width="390pt"
            height="auto"
          />
        </a>
      ) : null}
      {showControls ? (
        <>
          <div data-no-copy="true">
            <ToggleInput type={"tel"} placeholder={"Digite o número do telefone"} value={customPhone} onChange={handleChange} />
          </div>
        </>
      ) : null}
    </span>
  );
};
